import type { Point } from "../canvas/canvasTypes";
import type { Rect } from "../comic/comicTypes";

export type ShapeTool = "line" | "rectangle" | "ellipse";
export type ShapeMode = "outline" | "solid";

export interface ShapeGeometry {
  readonly start: Readonly<Point>;
  readonly end: Readonly<Point>;
}

export interface ShapeStyle {
  readonly colour: string;
  readonly size: number;
  readonly opacity: number;
  readonly mode: ShapeMode;
}

export interface ActiveShape {
  readonly tool: ShapeTool;
  readonly layerId: string;
  readonly geometry: ShapeGeometry;
  readonly style: ShapeStyle;
  readonly clipRect: Readonly<Rect>;
  readonly panelId?: string;
}

export function isShapeTool(value: unknown): value is ShapeTool {
  return value === "line" || value === "rectangle" || value === "ellipse";
}
